/* AIMALL SEARCH ROUTING V1.3: refine only audited intents; retain an explicit broad-search escape. */
(function () {
  'use strict';
  if (window.AimallSearchRules) return;
  var rules = [{"label": "usb string", "aliases": ["usb string"], "nativeQuery": "title:usb AND (title:string OR title:fairy) AND title:light* -tag:unsalable"}, {"label": "stylus pen", "aliases": ["stylus pen"], "nativeQuery": "(title:stylus OR (title:capacitive AND title:pen)) -title:tip* -title:nib* -tag:unsalable"}, {"label": "power board", "aliases": ["power board"], "nativeQuery": "title:power AND (title:board OR title:strip) -title:box -title:holder -title:organis* -title:bracket* -title:thermostat -tag:unsalable"}, {"label": "papier fleuriste", "aliases": ["papier fleuriste"], "nativeQuery": "(title:flower OR title:floral) AND title:wrapping AND title:paper -tag:unsalable"}, {"label": "onesie", "aliases": ["onesie"], "nativeQuery": "title:onesie* -title:cat -title:dog -tag:unsalable"}, {"label": "pixel 8a case", "aliases": ["pixel 8a case", "google pixel 8a case"], "nativeQuery": "title:pixel AND title:8a AND (title:case OR title:cover) -tag:unsalable"}, {"label": "bowser", "aliases": ["bowser"], "nativeQuery": "title:bowser* -tag:unsalable"}, {"label": "kraft sticker", "aliases": ["kraft sticker"], "nativeQuery": "title:kraft AND (title:sticker* OR title:label*) -title:bags -title:handheld -tag:unsalable"}];
  function normalized(q) { return String(q || '').trim().toLowerCase().replace(/\s+/g, ' '); }
  function ruleFor(q) {
    var key = normalized(q);
    return rules.find(function (r) { return normalized(r.nativeQuery) === key || r.aliases.some(function (a) { return normalized(a) === key; }); });
  }
  function display(q) { var r = ruleFor(q); return r ? r.label : String(q || '').trim(); }
  function searchUrl(url, q, broad) {
    var r = ruleFor(q);
    url.searchParams.set('q', r && !broad ? r.nativeQuery : display(q));
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[unavailable_products]', 'hide');
    url.searchParams.set('options[prefix]', r && !broad ? 'none' : 'last');
    if (broad) url.searchParams.set('aimall_broad', '1');
    else url.searchParams.delete('aimall_broad');
    return url;
  }
  window.AimallSearchRules = { displayQuery: display, normalizeQuery: display, ruleFor: ruleFor };
  // Capture normal search submissions, before the native navigation. Do not touch filter forms.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (e.defaultPrevented) return;
    // Filter forms keep their own native query and facets; persist a broad-search choice.
    if (form && (form.id === 'filter' || form.classList.contains('f8fl'))) {
      if (new URL(window.location.href).searchParams.get('aimall_broad') === '1' && !form.querySelector('input[name="aimall_broad"]')) {
        var flag = document.createElement('input'); flag.type = 'hidden'; flag.name = 'aimall_broad'; flag.value = '1'; form.appendChild(flag);
      }
      return;
    }
    if (!form || form.id === 'filter' || form.classList.contains('f8fl') || form.method.toLowerCase() !== 'get') return;
    var url = new URL(form.action, window.location.href);
    if (url.origin !== window.location.origin || !/\/search\/?$/.test(url.pathname)) return;
    var input = form.querySelector('input[name="q"]');
    if (!input || !input.value.trim()) return;
    if (!ruleFor(input.value)) return;
    form.dataset.aimallHumanQuery = input.value.trim();
    var broad = new URL(window.location.href).searchParams.get('aimall_broad') === '1' && normalized(input.value) === normalized(document.querySelector('[data-aimall-search-page]')?.dataset.query);
    new FormData(form).forEach(function(value, name){ if (typeof value === 'string') url.searchParams.append(name,value); });
    searchUrl(url, input.value, broad);
    var preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    e.preventDefault();
    setTimeout(function () { window.location.assign(url.href); }, 0);
  }, true);
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest && e.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    var url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || !/\/search\/?$/.test(url.pathname) || !url.searchParams.has('q')) return;
    if (url.searchParams.get('aimall_broad') === '1') return;
    var currentBroad = new URL(window.location.href).searchParams.get('aimall_broad') === '1';
    if (currentBroad && normalized(display(url.searchParams.get('q'))) === normalized(document.querySelector('[data-aimall-search-page]')?.dataset.query)) {
      url.searchParams.set('aimall_broad','1');
      link.href = url.href;
      return;
    }
    var r = ruleFor(url.searchParams.get('q'));
    if (!r || normalized(url.searchParams.get('q')) === normalized(r.nativeQuery)) return;
    searchUrl(url, url.searchParams.get('q'), false);
    var preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    e.preventDefault();
    setTimeout(function () { window.location.assign(url.href); }, 0);
  });
  // Old shared search URLs also use the audited rule, preserving active filters and pagination.
  var current = new URL(window.location.href);
  if (current.searchParams.get('aimall_broad') === '1') {
    function preserveBroadFilters(){
      var filterForm = document.querySelector('form#filter');
      if (filterForm && !filterForm.querySelector('input[name="aimall_broad"]')) {
        var flag = document.createElement('input'); flag.type='hidden'; flag.name='aimall_broad'; flag.value='1'; filterForm.appendChild(flag);
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',preserveBroadFilters); else preserveBroadFilters();
  }
  if (/\/search\/?$/.test(current.pathname) && current.searchParams.has('q') && current.searchParams.get('aimall_broad') !== '1') {
    var r = ruleFor(current.searchParams.get('q'));
    if (r && normalized(current.searchParams.get('q')) !== normalized(r.nativeQuery)) {
      searchUrl(current, current.searchParams.get('q'), false);
      current.searchParams.delete('page');
      window.location.replace(current.href);
    }
  }
})();
